import {
  WSElement,
  WSFlexBox,
  WSImage,
  WSInfoBox,
  WSInfoBoxProps,
  WSList,
  WSScreen,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import previewImage from "../../../assets/PGLIImage1.png";
import { PLAN_DETAILS } from "../../../utils/constants";

const {
  monthlyPremiumFormatted,
  initiationFeeFormatted,
  monthlyPremium,
  initiationFee
} = PLAN_DETAILS["WingspanProfessionalLiabilityAndGeneralLiabilityInsurance"];

export const PGLIEnrollmentFeesInfoBox = (props: Partial<WSInfoBoxProps>) => (
  <WSInfoBox title="Cost & deductions" icon="out" {...props}>
    <WSText.ParagraphSm mb="M">
      <b>Monthly premium:</b> {monthlyPremiumFormatted} per month.
    </WSText.ParagraphSm>
    <WSText.ParagraphSm mb="M">
      <b>Initiation fee:</b> A one-time {initiationFeeFormatted!} fee is charged
      upon first-time enrollment. (Your first month's total cost will be $
      {monthlyPremium + initiationFee!}).
    </WSText.ParagraphSm>
    <WSText.ParagraphSm mb="M">
      <b>Automatic payments:</b> We will first attempt to deduct the premium
      from your incoming payments processed through Wingspan. If your earnings
      do not cover the premium by the end of the month, we will charge your
      payment method on file.
    </WSText.ParagraphSm>
    <WSList.Horizontal wrap="nowrap" equalItems>
      <WSFlexBox.CenterY>
        <WSElement>
          <WSText.ParagraphSm weight="medium" mb="S">
            Example:
          </WSText.ParagraphSm>
          <WSText.ParagraphSm mb="S">
            Signing up on January 1 and using automatic deductions.
          </WSText.ParagraphSm>
          <WSText.ParagraphSm weight="medium" mb="XS">
            First payment:
          </WSText.ParagraphSm>
          <WSElement as="ul" mb="S">
            <li>January: {monthlyPremiumFormatted}</li>
            <li>February: {monthlyPremiumFormatted}</li>
            <li>Setup fee: {initiationFeeFormatted!}</li>
            <li>
              <b>Total: ${monthlyPremium + monthlyPremium + initiationFee!}</b>
            </li>
          </WSElement>
          <WSText.ParagraphSm>
            <b>Ongoing monthly fee:</b> <br />
            After enrollment, you'll pay a flat {monthlyPremiumFormatted}/month,
            billed in advance. <br />
          </WSText.ParagraphSm>
          <ul>
            <li>
              <b>March fee</b> is deducted from your January–February invoices
            </li>
            <li>
              <b>April fee</b> is deducted from your February–March invoices,
              and so on
            </li>
          </ul>
        </WSElement>
      </WSFlexBox.CenterY>

      <WSScreen.TabletAndDesktop>
        <WSImage
          src={previewImage}
          width={175}
          placeholder={<WSElement py="6XL" shimmer />}
        />
      </WSScreen.TabletAndDesktop>
    </WSList.Horizontal>
    <WSScreen.Mobile>
      <WSImage
        src={previewImage}
        placeholder={<WSElement py="6XL" shimmer />}
      />
    </WSScreen.Mobile>
  </WSInfoBox>
);

export const PGLIManagingYourPolicy = (props: Partial<WSInfoBoxProps>) => (
  <WSInfoBox title="Managing your policy" icon="bulb" {...props}>
    <WSText.ParagraphSm mb="M">
      <b>Instant compliance:</b> Once enrolled, you can instantly use this
      policy to satisfy Professional and General Liability requirements for your
      clients on Wingspan.
    </WSText.ParagraphSm>
    <WSText.ParagraphSm mb="M">
      <b>Cancellation:</b> You can cancel your enrollment at any time through
      your Wingspan insurance dashboard. Cancellation takes effect at the end of
      the current month, and pro-rata refunds will be processed for unused
      coverage periods.
    </WSText.ParagraphSm>
  </WSInfoBox>
);
